import React, { Component } from 'react';
import { Button, Form, Grid, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';

import axios from 'axios';
import { fetchStudyCycle } from '../../Lookups/util';
import PaginationFront from '../../util/PaginationFront';
import ReportExcelFile from './ReportExcelFile';
import ExcelSheet from 'react-data-export/dist/ExcelPlugin/elements/ExcelSheet';
import {
    additionalFilterSectionStyle,
    requiredFilterSectionStyle,
    filterFieldGridStyle,
    shouldShowOrgUnitFilter
} from './reportUiHelpers';


class CourseListPerCycle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            studyCycles: [],
            studyCycleId: null,
            orgUnit: null,

            studyProgramBasics: [],
            studyProgramBasicId: null,
            search: '',
            activePage: 1,
            loader: false,
            reportRequested: false,

            orgUnitFilter: shouldShowOrgUnitFilter(localStorage.getItem('activeRole')),


        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        if (localStorage.getItem('orgUnit')) {
            this.setState({ orgUnit: parseInt(localStorage.getItem('orgUnit'), 10) });
        }
        this.getSPB();
        fetchStudyCycle().then(res => this.setState({
            studyCycles: res.data.map(el => ({ key: el.id, value: el.id, text: el.displayName }))
        })).catch(() => this.setState({ error: 'Nije moguće učitati cikluse studija. Osvježite stranicu.' }));
    }


    getSPB(orgUnitId) {
        const orgUnit = orgUnitId || this.state.orgUnit || localStorage.getItem('orgUnit');
        const url = this.state.orgUnitFilter
            ? (orgUnit ? `study-programs/basic/${orgUnit}` : 'study-programs/basic/all')
            : 'study-programs/basic';

        let obj = {};
        axios.post(url, { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                this.setState({ studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'orgUnit') {
            const url = value ? `study-programs/basic/${value}` : 'study-programs/basic/all';
            let obj = {};
            axios.post(url, { ...obj })
                .then(res => {
                    const studyProgramBasics = res.data.map((el) => ({
                        ...el,
                        value: el.studyProgramBasic.id,
                        key: el.studyProgramBasic.id,
                        text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                        description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                    })).filter(e => e.studyProgramBasic.archived === false);

                    this.setState({ studyProgramBasics });
                })
                .catch(err => {
                    console.log('Failed to fetch study program basics. ', err);
                });
        }


        this.setState({
            [name]: value,
            data: [],
            loader: false,
            reportRequested: false,
            error: null,
            search: '',
            activePage: 1
        }, () => {
            if (name === 'orgUnit') {
                this.setState({ studyProgramBasicId: null });
            }
        });
    }

    getData(studyProgramBasicId = -1, archived = 0, orgUnit = this.state.orgUnit) {
        if (!this.state.studyCycleId) return;
        const organizationalUnitId = orgUnit || -1;
        const studyCycleId = this.state.studyCycleId;

        this.setState({ loader: true, reportRequested: true, error: null, search: '', activePage: 1 });
        axios.get(this.state.orgUnitFilter ? `reports/courses-per-study-cycle/${archived}/${organizationalUnitId}/${studyProgramBasicId}`
            : `reports/courses-per-study-cycle/${archived}/${studyProgramBasicId}`)
            .then(res => {
                this.setState({
                    loader: false,
                    data: res.data.filter(el => el.studyCycleId === studyCycleId)
                });
            }).catch(() => this.setState({ loader: false, data: [], error: 'Nije moguće učitati izvještaj. Pokušajte ponovo.' }));
    }

    getDataToRender() {
        const search = this.state.search.toLocaleLowerCase('bs');
        return this.state.data.filter(el => [el.courseName, el.comment]
            .some(value => (value || '').toLocaleLowerCase('bs').includes(search)));
    }

    render() {
        const multiDataSet = [
            {
                columns: [
                    { title: 'Predmet', width: { wpx: 350 } },
                    { title: 'Komentar', width: { wpx: 250 } },
                ],
                data: [],
            }
        ];
        const { data, loader, reportRequested, error, activePage } = this.state;
        const filteredData = this.getDataToRender();
        multiDataSet[0].data = filteredData.map((el, index) => [
            { value: (index + 1) + '. ' + el.courseName }, { value: el.comment || '' }
        ]);
        return (
            <div>
                <Form>
                    <Segment style={requiredFilterSectionStyle}>
                        <Header as="h4" color="blue">Obavezni parametri</Header>
                        <Form.Group widths="equal">
                            <Form.Dropdown required label="Ciklus studija" placeholder="Odaberite ciklus studija"
                                options={this.state.studyCycles} value={this.state.studyCycleId}
                                name="studyCycleId" onChange={this.handleInputChange}
                                disabled={loader} search fluid selection />
                            <Form.Field />
                        </Form.Group>
                    </Segment>
                    <Segment style={additionalFilterSectionStyle}>
                        <Header as="h4" color="blue">Dodatni filteri</Header>
                        <Form.Group widths="equal" style={filterFieldGridStyle}>
                            {this.state.orgUnitFilter && <Form.Field>
                                <Form.Dropdown
                                    clearable
                                    label="Organizaciona jedinica"
                                    placeholder="Organizaciona jedinica"
                                    value={this.state.orgUnit}
                                    onChange={this.handleInputChange}
                                    name="orgUnit"
                                    options={this.props.organizationalUnits || []}
                                    search
                                    fluid
                                    selection
                                    disabled={loader}
                                />
                            </Form.Field>}
                            <Form.Field>
                                <Form.Dropdown
                                    label="Studijski program"
                                    clearable
                                    placeholder="Odaberite studijski program"
                                    options={this.state.studyProgramBasics}
                                    onChange={this.handleInputChange}
                                    name="studyProgramBasicId"
                                    disabled={loader}
                                    value={this.state.studyProgramBasicId}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            {!this.state.orgUnitFilter && <Form.Field />}
                        </Form.Group>
                    </Segment>
                    <Button basic color="blue" floated="right" onClick={this.props.closeReport}>
                        Odustani
                    </Button>
                    <Button
                        color="blue"
                        floated="right"
                        disabled={loader || !this.state.studyCycleId}
                        onClick={() => this.getData(this.state.studyProgramBasicId ? this.state.studyProgramBasicId : -1, 0)}
                    >
                        Prikaži izvještaj
                    </Button>
                </Form>

                <br /><br /><br />

                {loader ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div>
                    :
                    <div>

                    {error || (reportRequested && data.length ? <Table celled selectable compact>

                            <Table.Header>
                            <Table.Row>
                                    <Table.HeaderCell>
                                    <Grid columns={2} stackable>
                                            <Grid.Column width={12}>
                                            <Form.Input fluid icon="search" placeholder="Pretraga" value={this.state.search}
                                                onChange={(event, { value }) => this.setState({ search: value, activePage: 1 })} />
                                        </Grid.Column>
                                            <Grid.Column width={4} textAlign="center">
                                            <ReportExcelFile
                                                    filename="Predmeti po ciklusima"
                                                    element={<Popup
                                                        trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}
                                                >
                                                    <ExcelSheet dataSet={multiDataSet} name="Predmeti" />
                                                </ReportExcelFile>

                                        </Grid.Column>
                                        </Grid>
                                </Table.HeaderCell>
                                </Table.Row>
                            <Table.Row>
                                    <Table.HeaderCell > Predmet </Table.HeaderCell>

                                </Table.Row>
                        </Table.Header>
                            <Table.Body> {filteredData.slice((activePage - 1) * 25, activePage * 25).map((el, index) =>
                                (<Table.Row key={el.studyCycleId + '-' + el.courseId}>

                                    <Table.Cell verticalAlign="middle">{(activePage - 1) * 25 + index + 1}. {el.courseName}{el.comment && <div style={{ color: '#777', fontSize: '0.9em' }}>{el.comment}</div>}</Table.Cell>

                                </Table.Row>))}
                        </Table.Body>
                            <Table.Footer><Table.Row><Table.HeaderCell>
                                {filteredData.length > 0 ? <PaginationFront postsPerPage={25} totalPosts={filteredData.length} activePage={activePage}
                                    paginate={(event, { activePage: page }) => this.setState({ activePage: page })} /> : 'Nema podataka za zadanu pretragu.'}
                            </Table.HeaderCell></Table.Row></Table.Footer>
                        </Table> : reportRequested ? 'Nema podataka.' : null)}
                </div>


                }

            </div>
        );
    }
}

export default CourseListPerCycle;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/CourseListPerCycle.js